import React from 'react'
import style from './Verify.Module.css'
import progress from '../../Assets/verify/Group 193.png'
import image from '../../Assets/verify/Rectangle 249.png'
import Header from '../../Component/Header'
import { useNavigate } from 'react-router';

const VerifyTwo = () => {
    let navigate = useNavigate();
  function handleClick() {
    navigate('/verifyStep3')
    }
    return (
        
        <div className={style.mainContainer}>
            <Header/>
        <div className={style.main}>
          <div className={style.boxContainer}>
            <div className={style.boxInsidecontainer}>
            
                    <div><h1 className={style.verifyHeading}>Verify your account</h1></div>
                    <div><img src={progress} alt="progress bar"/></div>
                    <div className={style.imageHolder}><img src={image} alt="sample pictur"/></div>
                    <div><p className={style.verifyParagraph}>To verify yourself take a picture with the same<br/>gestures as the one above</p></div>
                    <div><button className={style.mainButton} onClick={handleClick}>Ready</button></div>
                    <div><p className={style.verifyParagraph}>This picture will not be used for verification and will<br/> not be shown to others</p></div>
                
            </div>
        </div>
        </div>
        </div>
    )

}

export default VerifyTwo
